import { create } from '@bufbuild/protobuf';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { secretApi } from '@/api/secret.api';
import { ListRequestSchema } from '@/proto/agentplatform/common/http_pb';
import type { Secret } from '@/proto/agentplatform/v2/secret_pb';

const QK = ['secrets', 'list'] as const;

export function useSecrets(page = 1, pageSize = 10) {
  return useQuery({
    queryKey: [...QK, page, pageSize] as const,
    queryFn: () => secretApi.listSecrets(create(ListRequestSchema, { page, pageSize })),
  });
}

export function useCreateSecret() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (secret: Secret) => secretApi.createSecret(secret),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: QK });
    },
  });
}

export function useUpdateSecret() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, secret }: { id: string; secret: Secret }) =>
      secretApi.updateSecret(id, secret),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: QK });
    },
  });
}

export function useDeleteSecret() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => secretApi.deleteSecret(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: QK });
    },
  });
}
